module.exports = __webpack_public_path__ + "static/media/answer1.fc16fdb5.png";